<template>
  <div class="rep-example-box">
    <p>Subject to credit and affordability assessments. Rep Example:
      If you borrow <span v-html="repExample.loanAmount"></span> over {{repExample.termInMonths}} months at a fixed monthly interest rate of {{repExample.interest}}% and an annual rate of {{repExample.annualRate}}% and representative
      annual percentage rate of {{repExample.APR}}% You will pay: Monthly payment: <span v-html="repExample.monthlyPaymentAmount"></span>. Total repayment: <span v-html="repExample.totalAmountToPay"></span> Total charge for credit: <span v-html="repExample.totalCredit"></span>.
      Missed payments may affect your credit file, future borrowing and incur fees.</p>
  </div>
</template>
<script>



export default {
  components: {},
  props: {
    installmentsInfo: Object,
    repExample: Object,
    deposit: Number,
    amount: Number
  }
};
</script>